// The help desk ticket types (packages/shared/src/ticket-types.json): staff see the name, clients their own wording.
import ticketTypes from '@platform/shared/ticket-types.json'

export interface TicketType {
  key: string
  name: string
  clientLabel: string
  order: number
}

export const TICKET_TYPES: TicketType[] = [...ticketTypes].sort((a, b) => a.order - b.order)

const byKey = new Map(TICKET_TYPES.map(type => [type.key, type]))
const OTHER_LABEL = byKey.get('other')?.clientLabel ?? 'Something else'

export const typeName = (key: string) => byKey.get(key)?.name ?? key
export const clientTypeLabel = (key: string) => byKey.get(key)?.clientLabel ?? OTHER_LABEL
